import { styled } from "@mui/material/styles";
const QuotLocationMain = styled("div")(({ theme }) => ({
  height: "100vh",
  minHeight: "100vh",
  width: "100%",
  position: "relative",
  zIndex: 3,
}));
const HeaderMain = styled("div")(({ theme }) => ({
  position: "absolute",
  top: "0px",
  left: "10%",
  transform: "translateX(-10%)",
  width: "100%",
  zIndex: 1,
  "& .breadcrumbs": {
    background: "#FFFFFF !important",
    border: "0.25px solid rgba(30, 39, 56, 0.2)",
    boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.08)",
  },
}));
const ButtonMain = styled("div")(({ theme }) => ({
  display: "flex",
  gap: "15px",
  position: "absolute",
  top: "70%",
  left: "50%",
  transform: "translateX(-50%)",
  width: "55%",
  zIndex: 1,
  [theme.breakpoints.down("md")]: {
    flexDirection: "column-reverse",
    width: " 90%",
    "& button:first-of-type": {
      marginTop: "0px",
    },
  },
}));

export { QuotLocationMain, HeaderMain, ButtonMain };
